/** Base path for réception nested routes */
export const RECEP_BASE = '/receptionist';

export const RECEP_PATHS = {
  DASHBOARD: RECEP_BASE,
  APPOINTMENTS: `${RECEP_BASE}/rendez-vous`,
  REPORTING: `${RECEP_BASE}/reporting`,
  COMPANIES: `${RECEP_BASE}/societes`,
  MEMBERS: `${RECEP_BASE}/adherents`,
  EXTERNAL_MEMBERS: `${RECEP_BASE}/membres-externes`
};

/** Sidebar / mobile navigation (order = display order) */
export const RECEP_NAV_ITEMS = [
  {
    to: RECEP_PATHS.DASHBOARD,
    end: true,
    label: 'Tableau de bord',
    shortLabel: 'Accueil',
    hint: 'Accueil & flux du jour',
    icon: 'dashboard'
  },
  {
    to: RECEP_PATHS.APPOINTMENTS,
    end: false,
    label: 'Rendez-vous',
    shortLabel: 'RDV',
    hint: 'Planification & suivi',
    icon: 'appointments'
  },
  {
    to: RECEP_PATHS.REPORTING,
    end: false,
    label: 'Reporting & historique',
    shortLabel: 'Reporting',
    hint: 'Période, export CSV',
    icon: 'reporting'
  },
  {
    to: RECEP_PATHS.COMPANIES,
    end: false,
    label: 'Sociétés',
    shortLabel: 'Sociétés',
    hint: 'Annuaire partenaires',
    icon: 'companies'
  },
  {
    to: RECEP_PATHS.MEMBERS,
    end: false,
    label: 'Adhérents',
    shortLabel: 'Adhérents',
    hint: 'Consultation & fiches',
    icon: 'members'
  },
  {
    to: RECEP_PATHS.EXTERNAL_MEMBERS,
    end: false,
    label: 'Membres externes',
    shortLabel: 'Externes',
    hint: 'Patients hors SMIE',
    icon: 'external'
  }
];
